import { HUMAN_REVIEWED_TAG } from '@/constants';
import type { PageExperience } from '@/features/experiences/types';

import { ExperienceBadgeGroup } from './ExperienceBadgeGroup';

type Props = {
  experience: PageExperience;
};

export const ExperienceBadges = ({ experience }: Props) => {
  const isHumanReviewed = experience.directoryTags.some(
    (tag) => tag.text === HUMAN_REVIEWED_TAG
  );

  return (
    <ExperienceBadgeGroup
      badges={
        isHumanReviewed
          ? ['made-with-magic', 'human-reviewed']
          : ['made-with-magic']
      }
    />
  );
};
